import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import AppIcon from '@/components/generals/app-icon'

interface AppLogoProps {
    href?: string
    className?: string
}

const AppLogo: FC<AppLogoProps> = ({ href = '#top', className }): ReactNode => {
    return (
        <a
            href={href}
            aria-label="MultiScreen Video Studio, back to top"
            className={cn('group inline-flex items-center gap-3 rounded-lg', className)}
        >
            <AppIcon className='size-10 transition-transform duration-300 group-hover:-rotate-6' />

            <span className='flex flex-col leading-none'>
                <span className='font-heading text-[1.3rem] font-extrabold tracking-[-0.03em] text-foreground'>
                    MultiScreen
                </span>

                <span className='mt-1 text-[0.58rem] font-bold uppercase tracking-[0.32em] text-muted-foreground'>
                    Video Studio
                </span>
            </span>
        </a>
    )
}

export default AppLogo
